import React, { useEffect, useRef, useState } from 'react'
import { Input } from '@workwhile/ui'

type DeliveryHourInputProps = {
  value: number | null | undefined
  onChange: (value: number | null) => void
}

function toDisplayValue(value: number | null | undefined) {
  if (value == null || Number.isNaN(value)) {
    return ''
  }
  return String(value)
}

export const DeliveryHourInput = ({
  value,
  onChange,
}: DeliveryHourInputProps) => {
  const [text, setText] = useState(toDisplayValue(value))
  const isFocusedRef = useRef(false)

  useEffect(() => {
    if (isFocusedRef.current) {
      return
    }
    setText(toDisplayValue(value))
  }, [value])

  return (
    <Input
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={text}
      placeholder="-2"
      onFocus={() => {
        isFocusedRef.current = true
      }}
      onBlur={() => {
        isFocusedRef.current = false
        if (text === '' || text === '-') {
          setText('')
          onChange(null)
          return
        }
        setText(toDisplayValue(Number(text)))
      }}
      onChange={(event) => {
        const raw = event.target.value
        if (raw === '' || raw === '-') {
          setText(raw)
          onChange(null)
          return
        }
        if (!/^-?\d{1,2}$/.test(raw)) {
          return
        }
        setText(raw)
        onChange(Number(raw))
      }}
    />
  )
}
